import React, { useContext } from 'react';
import '@fontsource/roboto';
import { GameContext } from '../entities/GameContext'
import DoubleSetup from './DoubleSetup';
import GameOngoing from './GameOngoing';

function Double() {
    const { started } = useContext(GameContext);

    console.log("Double game started:", started)

    if (started) {
        return (<GameOngoing />);
    }else{
        return (<DoubleSetup />);
    }

}

export default Double;
